import cuid from "cuid";
import { get } from "lodash";
import omitDeep from "omit-deep-lodash";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { TRACER } from "utils/api/graphql/queries/tracers";
import { persistProcessRuntime } from "screens/Private/Broker/Projects/Detail/resolveProcessRuntime";
import { KEYS, PROJECT_TYPES, SALE_MODES, SCREENS } from "utils/constants";

const Create = () => {
  const navigate = useNavigate();
  const [addProject] = useMutation(graphql.mutations.CREATE_PROJECT);
  const { src } = useParams();
  const { user } = useLocation().state;
  const hash = window.location.hash;
  const queryString = hash.includes("?") ? "?" + hash.split("?")[1] : "";
  useQuery(TRACER, {
    fetchPolicy: "no-cache",
    variables: {
      where: { source: { id: src } },
    },
    onCompleted: ({ tracer }) => {
      const trackonReqid = localStorage.getItem(KEYS.TRACKON_REQID);
      const status = omitDeep(
        get(tracer, "flow.process.processStatuses", []),
        "__typename",
      ).reduce((previous, current) =>
        Number(previous?.order) < Number(current.order) ? previous : current,
      );
      addProject({
        variables: {
          data: {
            id: cuid(),
            statuses: [{ id: cuid(), status: { id: get(status, "id") } }],
            projectType: PROJECT_TYPES.HOT_LEAD,
            contract: {
              id: cuid(),
              saleMode: SALE_MODES.DISTANT,
            },
            contact: {
              id: cuid(),
              user: {
                id: get(user, "id"),
              },
            },
            tracer: { id: get(tracer, "id") },
            fields: {
              processTemplate: get(tracer, "flow.process.theme"),
              ...(trackonReqid && { trackon: { reqid: trackonReqid } }),
            },
            visible: false,
          },
        },
        onCompleted: ({ addProject }) => {
          const cleanTracer = omitDeep(tracer, "__typename");
          const process = get(cleanTracer, "flow.process");
          localStorage.setItem(KEYS.PROJECT_ID, addProject?.id);
          persistProcessRuntime(addProject?.id, process, cleanTracer);
          navigate(
            `${SCREENS.PRIVATE.GUEST.PROJECTS.DETAIL.path}/${addProject?.id}${queryString}`,
            {
              state: {
                process,
                tracer: cleanTracer,
              },
            },
          );
        },
      });
    },
  });
};

export default Create;
